import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 419C0A49-C751-4204-8C82-7E43B0896BD9
 * name widgets
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/widgets.svg
 * tags
 */
export const WidgetsIcon = createSvgIcon(<><path d="M3,3H11V7.34L16.66,1.69L22.31,7.34L16.66,13H21V21H13V13H16.66L11,7.34V11H3V3M3,13H11V21H3V13Z" /></>, 'WidgetsIcon');
export default WidgetsIcon